import React from "react";

const Grid = ({ className, children }) => {
  return <div className={className}>{children}</div>;
};
export default Grid;
